/* External */
import {
  memo,
} from 'react';
import PropTypes from 'prop-types';
import { withFocusable } from '@noriginmedia/react-spatial-navigation';

/* Components */
import QrCode from '../QrCode';

/* Styles */
import './UpsellPlayerBanner.scss';

function UpsellPlayerBanner({
  message,
  link,
  className,
}) {
  return (
    <div className={`dtv-html5-c-up-sell-player-banner ${className}`}>
      {link && (
        <div className="dtv-html5-c-up-sell-player-banner__qr-code-content">
          <QrCode
            data={link}
            className="dtv-html5-c-up-sell-player-banner__qr-code"
          />
        </div>
      )}
      {message && (
        <div className="dtv-html5-c-up-sell-player-banner__content">
          {message}
        </div>
      )}
    </div>
  );
}

UpsellPlayerBanner.propTypes = {
  message: PropTypes.string.isRequired,
  link: PropTypes.func.isRequired,
  className: PropTypes.string,
};

UpsellPlayerBanner.defaultProps = {
  className: '',
};

export default memo(withFocusable()(memo(UpsellPlayerBanner)));
